import { motion } from "framer-motion";
import Backdrop from "./backdrop";
import { PropTypes } from 'prop-types';
import { MdClose } from "react-icons/md";

const popup = {
    hidden: {
      scale: 0,
      opacity: 0,
      transformOrigin: "center",
      transition: {
        delay: 0.3,
      },
    },
    visible: {
      scale: 1,
      opacity: 1,
      transformOrigin: "center",
      transition: {
        duration: 0.5,
      },
    },
    exit: {
      scale: 0,
      opacity: 0,
      transformOrigin: "center",
      transition: {
        duration: 0.5,
      },
    },
  };


const Modal = ({ children, handleClose,css="p-4 text-black" }) => {

    return (
        <Backdrop onClick={handleClose}>
            <motion.div
                onClick={(e) => e.stopPropagation()}
                className="modal orange-gradient"
                variants={popup}
                initial="hidden"
                animate="visible"
                exit="exit"
                style={{
                    zIndex:"99999 !important"
                }}
            >
                <div className={`relative overflow-hidden flex flex-col gap-5 ${css} w-full h-full bg-white rounded-2xl  shadow-xl  backdrop-blur-lg`}
                // style={{
                //     zIndex:"99999 !important"
                // }}
                >
                    <button type="button" className="self-end text-inherit absolute top-5 right-5" onClick={handleClose}><MdClose size={25}/></button>
                    {children}
                </div>

            </motion.div>
        </Backdrop>
    );
};

Modal.propTypes = {
    handleClose: PropTypes.func,
    children: PropTypes.node,
}
export default Modal;